import React from 'react';
import Header from './Header';

import '../Styles/App.css';

import Home from './Home';
import AdvancedSearch from './AdvancedSearch';
import Login from './Login';
import Register from './Register';
import Recipe from './Recipe';
import User from './User';
import Add from './Add';
import Edit from './Edit';
import NotFound from './NotFound';

import { Routes, Route, BrowserRouter } from 'react-router-dom';


function App() {
    const updatenav = React.useState(false);
    const routes = [
        {
            path: '/',
            element: <Home />,
            inNav: true,
            display: 'Accueil',
            whenConnected: true,
            whenDisconnected: true
        },
        {
            path: '/advanced-search',
            element: <AdvancedSearch />,
            inNav: true,
            display: 'Recherche avancée',
            whenConnected: true,
            whenDisconnected: true
        },
        {
            path: '/login',
            element: <Login updatenav={updatenav}/>,
            inNav: true,
            display: 'Connexion',
            whenConnected: false,
            whenDisconnected: true
        },
        {
            path: '/register',
            element: <Register />,
            inNav: true,
            display: 'Inscription',
            whenConnected: false,
            whenDisconnected: true
        },
        {
            path: '/recipes/:id',
            element: <Recipe />,
            inNav: false,
            display: 'Recette',
            whenConnected: true,
            whenDisconnected: true
        },
        {
            path: '/add',
            element: <Add/>,
            inNav: true,
            display: 'Ajouter une recette',
            whenConnected: true,
            whenDisconnected: false,
            permissions: "Create"
        },
        {
            path: '/user/:id',
            element: <User updatenav={updatenav}/>,
            inNav: true,
            display: 'Compte',
            whenConnected: true,
            whenDisconnected: false
        },
        {
            path: '/edit/:id',
            element: <Edit />,
            inNav: false,
            display: 'Editer une recette',
            whenConnected: true,
            whenDisconnected: false
        },
        {
            path: '*' ,
            element: <NotFound/>,
            inNav: false,
            display: 'Page introuvable',
            whenConnected: true,
            whenDisconnected: true
        }
    ];

    return (
        <BrowserRouter id="App" basename="/gibli">
            <Header routes = {routes} updatenav={updatenav} />
            <Routes>
                {
                    routes.map((route, index) => {
                        return (
                            <Route key={index} path={route.path} element={route.element} />
                        );
                    }
                    )
                }
            </Routes>
        </BrowserRouter>
    );
}

export default App;
